import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./landing-page.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./landing-page.component.scss?ngResource";
import { Component } from "@angular/core";
import { LandingPageConstants } from "./landing-page.constants";
import { AppConfig } from "../../app.config";
import { LandingPageService } from "./shared/services/landing-page.service";
let LandingPageComponent = class LandingPageComponent {
    landingPageService;
    // header on the top left side of the page
    logoImageUrl;
    // header on the top left side of the page
    logoImageAlt;
    // login button
    loginButtonLabel = LandingPageConstants.LOGIN_TEXT;
    // Main banner background image url
    mainBannerBackgroundImageUrl;
    // Main banner heading
    mainBannerHeading;
    // Banner sub heading
    bannerSubHeading;
    // Banner content
    bannerContent;
    // about section heading
    aboutSectionHeading;
    // about section description
    aboutSectionDescription;
    // modules and tools main heading
    modulesAndToolsHeading;
    // modules and tools main sub-heading
    modulesAndToolsSubHeading;
    // list of module data
    modules = [];
    moduleRows = [];
    // screenshot section main header
    screenshotSectionMainHeader;
    // screenshot section sub header
    screenshotSectionSubHeader;
    // list of the images that are loaded on the carousel
    screenshots = [];
    // copyright
    copyrightText;
    moduleRowCount = 0;
    halfLastRow = false;
    showScreenshots = true;
    constructor(landingPageService) {
        this.landingPageService = landingPageService;
    }
    ngOnInit() {
        this.loadConfigData();
    }
    onLoginClicked() {
        this.landingPageService.loginButtonClicked.next(true);
    }
    loadConfigData() {
        const config = AppConfig.settings.landingPageData;
        this.logoImageUrl = config.logoImageUrl;
        this.logoImageAlt = config.logoImageAlt;
        this.mainBannerBackgroundImageUrl = config.mainBannerBackgroundImageUrl;
        this.mainBannerHeading = config.mainBannerHeading;
        this.bannerSubHeading = config.bannerSubHeading;
        this.bannerContent = config.bannerContent;
        this.aboutSectionHeading = config.aboutSectionHeading;
        this.aboutSectionDescription = config.aboutSectionDescription;
        this.modulesAndToolsHeading = config.modulesAndToolsHeading;
        this.modulesAndToolsSubHeading = config.modulesAndToolsSubHeading;
        if (config.screenshots["show"] === "false") {
            this.showScreenshots = false;
        }
        this.modules = [];
        let moduleRows = 0;
        // tslint:disable-next-line:forin
        for (const key in config.modules) {
            const module = config.modules[key];
            if (module.show.toString() === "true") {
                this.modules.push(module);
                moduleRows++;
            }
        }
        this.moduleRowCount = Math.ceil(moduleRows / 2);
        this.halfLastRow = Math.ceil(moduleRows / 2) !== moduleRows / 2;
        for (let i = 0; i < this.moduleRowCount; i++) {
            this.moduleRows.push(i);
        }
        this.screenshotSectionMainHeader = config.screenshotSectionMainHeader;
        this.screenshotSectionSubHeader = config.screenshotSectionSubHeader;
        this.screenshots = [];
        // tslint:disable-next-line:forin
        for (const key in config.screenshots) {
            const screenshot = config.screenshots[key];
            if (screenshot.show !== null && screenshot.show !== undefined) {
                if (screenshot.show.toString() === "true") {
                    this.screenshots.push(screenshot);
                }
            }
        }
        this.copyrightText = config.copyrightText;
    }
    static ctorParameters = () => [
        { type: LandingPageService }
    ];
};
LandingPageComponent = __decorate([
    Component({
        selector: "app-landing-page",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], LandingPageComponent);
export { LandingPageComponent };
